export const ASCENDINGNAME =    'ascendingName';
export const DESCENDINGNAME =   'descendingName';
export const ASCENDINGRATING =  'ascendingRating';
export const DESCENDINGRATING = 'descendingRating';
